<h1 mat-dialog-title>Quellen</h1>
<div mat-dialog-content class="sources-dialog__content">
    @if (dialogData.message?.sources?.length > 0) {
    <div class="sources-dialog__list">
        @for (source of dialogData.message.sources; track source) {
        @if (source.relatedApiPath === 'documents') {
        <div class="sources-dialog__item">
            <phito-file-downloader-button [documentHexId]="source.relatedId"></phito-file-downloader-button>
        </div>
        }
        }
        @if(documentationDocuments?.length>0){
        <phito-documentation-source [sources]="documentationDocuments"></phito-documentation-source>
        }
        @if(maintenanceDocuments?.length>0){
        <phito-maintenance-source [sources]="maintenanceDocuments"></phito-maintenance-source>
        }
    </div>
    } @else {
    <p>Keine Quellen vorhanden.</p>
    }
</div>
<div mat-dialog-actions>
    <button mat-button type="button" (click)="close()">Schließen</button>
    <button mat-flat-button type="button" (click)="close()">Ok</button>
</div>
